import client from './client';

export const listOrders = (params) => client.get('/orders', { params }).then((r) => r.data);
